<template>
  <v-container fluid class="py-2">
    <v-row>
      <v-col cols="12" md="6">
        <div>
          {{$t('batchreowrk.roadmaplist')}}
          <v-btn icon small class="ml-4 mb-1" @click="getRoadmapList">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
        <single-grid
        :height="'200px'"
        :headers="roadmapHeaders"
        :list="roadmapList"
        :reset="resetroadmap"
        @callback="(item)=>{roadmap = item}"
        />
        <div class="mt-2">
          {{$t('batchreowrk.orderlist')}}
          <v-btn icon small class="ml-4 mb-1" @click="getRoadmapList">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
        <single-grid
        :height="'200px'"
        :headers="orderHeaders"
        :list="orderList"
        :reset="resetorder"
        @callback="(item)=>{order = item}"
        />
        <v-card outlined class="mt-5">
          <v-card-title class="grey--text text--darken-1">
            {{$t('batchreowrk.descriptions')}}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <div class="grey--blue-grey text--lighten-2">
                  {{$t('batchreowrk.table.roadmap.name')}}
                </div>
                <div class="black--text text-h6">{{roadmapinfo.name || '-'}}</div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  {{$t('batchreowrk.table.roadmap.roadmaptype')}}
                </div>
                <div class="black--text text-h6">{{roadmapinfo.roadmaptype || '-'}}</div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  {{$t('batchreowrk.table.roadmap.reworkdescription')}}
                </div>
                <div class="black--text text-h6">{{roadmapinfo.reworkdescription || '-'}}</div>
              </v-col>
              <v-col cols="12" md="4">
                <div class="grey--blue-grey text--lighten-2">
                  {{$t('batchreowrk.table.order.ordername')}}
                </div>
                <div class="black--text text-h6">{{orderinfo.ordername || '-'}}</div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  {{$t('batchreowrk.table.order.customername')}}
                </div>
                <div class="black--text text-h6">{{orderinfo.customername || '-'}}</div>
              </v-col>
              <v-col cols="12" md="4">
                <div>
                  {{$t('batchreowrk.table.order.productname')}}
                </div>
                <div class="black--text text-h6">{{orderinfo.productname || '-'}}</div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              width="80"
              outlined
              text
              small
              :loading="saving"
              @click="handleResetroadmap"
            >
              {{$t('batchreowrk.resetbtn')}}
            </v-btn>
            <v-btn
              width="80"
              color="primary"
              small
              :disabled="order.length === 0
              || roadmap.length === 0
              || roadmapcomfirmed
              || ordercomfirmed"
              :loading="saving"
              @click="handleConform"
            >
              {{$t('batchreowrk.confirmbtn')}}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card></v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-row>
          <v-col cols="5">
            <v-text-field
              ref="mainid"
              label="Main ID"
              dense
              hide-details
              clearable
              autofocus
              :disabled="!roadmapcomfirmed || !ordercomfirmed"
              v-model="mainid"
              :loading="saving"
              @keyup.enter="scanMaid"
            >
            </v-text-field>
          </v-col>
          <v-col cols="7" class="d-flex flex-wrap">
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              outlined
              small
              color="error"
              v-show="selectedmainids.length > 0"
              @click="handleDeleteMainidist"
              :loading="saving"
            >
              <v-icon>mdi-delete</v-icon>
              {{$t('batchreowrk.deletebtn')}}
            </v-btn>
            <v-btn
              class="mr-2"
              outlined
              text
              small
              color="primary"
              v-show="selectedmainids.length === 0"
              :loading="saving"
              :disabled="!roadmapcomfirmed || !ordercomfirmed"
              @click="handleImport"
            >
              {{$t('batchreowrk.importbtn')}}
            </v-btn>
            <input
              type="file"
              accept=".csv"
              ref="uploader"
              class="d-none"
              id="uploadFiles"
              @change="onFilesChanged"
            />
            <v-btn
              class="mr-2"
              outlined
              text
              small
              color="primary"
              v-show="selectedmainids.length === 0"
              :loading="saving"
              @click="handleExport"
            >
              {{$t('batchreowrk.exportsamplebtn')}}
            </v-btn>
            <v-btn
              color="primary"
              small
              :loading="saving"
              v-show="selectedmainids.length === 0"
              :disabled="!roadmapcomfirmed || !ordercomfirmed || mainidlist.length === 0"
              @click="handleConfirmRework"
            >
              {{$t('batchreowrk.confirmreworkbtn')}}
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
        height="680"
        show-select
        v-model="selectedmainids"
        item-key="mainid"
        class="transparent"
        disable-pagination
        :items="mainidlist"
        hide-default-footer
        :headers="mainidHeaders"
        >
        <template #item.no="{index}">
          {{index + 1}}
        </template>
        <template #item.action="{index}">
          <v-btn icon small class="ml-4 mb-1" color="error" @click="handleDeleteMainid(index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        </v-data-table>
      </v-col>
    </v-row>
</v-container>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import CSVParser from '@shopworx/services/util/csv.service';
import ZipService from '@shopworx/services/util/zip.service';
import SingleGrid from '../Components/SingleGrid.vue';

export default {
  data() {
    return {
      roadmapTags: [
        'name',
        'roadmaptype',
        'reworkdescription',
      ],
      roadmap: [],
      roadmapList: [],
      roadmapHeaders: [],
      resetroadmap: 0,
      roadmapinfo: {},
      orderTags: [
        'ordername',
        'customername',
        'productname',
        'orderstatus',
      ],
      order: [],
      orderList: [],
      orderHeaders: [],
      resetorder: 0,
      orderinfo: {},
      mainid: '',
      roadmapcomfirmed: false,
      ordercomfirmed: false,
      mainidHeaders: [
        {
          text: 'No.',
          sortable: true,
          value: 'no',
        },
        {
          text: 'Main ID',
          sortable: false,
          value: 'mainid',
        },
        {
          text: this.$t('batchreowrk.table.ngcode'),
          sortable: false,
          value: 'ngcode',
        },
        {
          text: this.$t('batchreowrk.table.ngdescription'),
          sortable: false,
          value: 'ngdescription',
        },
        {
          text: this.$t('batchreowrk.table.action'),
          sortable: false,
          value: 'action',
        },
      ],
      selectedmainids: [],
      mainidlist: [],
      ngconfiglist: [],
      sublinelist: [],
      runningorder: [],
      saving: false,
    };
  },
  components: {
    SingleGrid,
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations('helper', ['setAlert']),
    ...mapActions('reworkOperation', ['getElement', 'postElement', 'postBulkElement', 'deleteElement']),
    async init() {
      this.roadmapHeaders = this.roadmapTags.map((tag, k) => ({
        headerName: this.$t(`batchreowrk.table.roadmap.${tag}`),
        field: tag,
        filter: 'agTextColumnFilter',
        checkboxSelection: k === 0 && true,
      }));
      this.orderHeaders = this.orderTags.map((tag, k) => ({
        headerName: this.$t(`batchreowrk.table.order.${tag}`),
        field: tag,
        filter: 'agTextColumnFilter',
        checkboxSelection: k === 0 && true,
      }));
      await this.getRoadmapList();
      await this.getOrder();
      await this.getNGconfigList();
      await this.getSublineId();
      this.zipService = ZipService;
      const roadmapid = localStorage.getItem('roadmapid');
      const orderid = localStorage.getItem('orderid');
      if (roadmapid) {
        this.roadmap = this.roadmapList.filter((item) => item.id === roadmapid);
        if (this.roadmap.length > 0) {
          this.roadmapinfo = { ...this.roadmap[0] };
          this.roadmapcomfirmed = true;
          this.ordercomfirmed = true;
          this.$nextTick(() => {
            this.$refs.mainid.focus();
          });
        }
      }
      if (orderid) {
        this.order = this.orderList.filter((item) => item.ordernumber === orderid);
        if (this.order.length > 0) {
          this.orderinfo = { ...this.order[0] };
          this.roadmapcomfirmed = true;
          this.ordercomfirmed = true;
          this.$nextTick(() => {
            this.$refs.mainid.focus();
          });
        }
      }
    },
    async getRoadmapList() {
      this.roadmapList = await this.getElement({
        elementname: 'roadmaplist',
        query: '?query=roadmaptype=="Rework"',
      });
    },
    async getNGconfigList() {
      this.ngconfiglist = await this.getElement({
        elementname: 'ngcodeconfig',
      });
    },
    async getSublineId() {
      this.sublinelist = await this.getElement({
        elementname: 'subline',
      });
    },
    async getOrder() {
      this.orderList = await this.getElement({
        elementname: 'order',
        query: '?query=visible==true%26%26(orderstatus=="Running"%7C%7Corderstatus=="Interrupted")',
      });
    },
    handleImport() {
      this.$refs.uploader.click();
    },
    async onFilesChanged(e) {
      const files = e && e !== undefined ? e.target.files : null;
      const csvParser = new CSVParser();
      const { data } = await csvParser.parse(files[0]);
      console.log(data, 'data');
      if (data && data.length === 0) {
        this.setAlert({
          show: true,
          type: 'error',
          message: this.$t('batchreowrk.importemptyalert'),
        });
        this.$refs.uploader.value = null;
        return;
      }
      if (data.some((i) => !i.mainid)) {
        this.setAlert({
          show: true,
          type: 'error',
          message: this.$t('batchreowrk.importformatalert'),
        });
        this.$refs.uploader.value = null;
        return;
      }
      const mainidarr = data.map((i) => i.mainid);
      if (data.length !== [...new Set(mainidarr)].length) {
        this.setAlert({
          show: true,
          type: 'error',
          message: this.$t('batchreowrk.importrepeatalert'),
        });
        this.$refs.uploader.value = null;
        return;
      }
      this.mainidlist = data.map((item, key) => ({
        ...item,
        ngcode: '-',
        ngdescription: '-',
        overallresult: 1,
        modestatus: 1,
        assetid: 4,
        key,
      }));
      this.$refs.uploader.value = null;
      this.setAlert({
        show: true,
        type: 'success',
        message: this.$t('batchreowrk.importsuccessalert'),
      });
    },
    async handleExport() {
      const csvContent = [
        ['mainid1'],
        ['mainid2'],
        ['mainid3'],
      ];
      const column = ['mainid'];
      const csvParser = new CSVParser();
      const content = csvParser.unparse({
        fields: column,
        data: csvContent,
      });
      this.addToZip({
        fileName: 'mainid.csv',
        fileContent: content,
      });
      const zip = await this.zipService.generateZip();
      this.zipService.downloadFile(zip, 'mainid.zip');
      this.zipService.removeFile({ fileName: 'mainid.csv' });
    },
    addToZip(file) {
      this.zipService.addFile(file);
    },
    handleConform() {
      localStorage.setItem('roadmapid', this.roadmap[0].id);
      localStorage.setItem('orderid', this.order[0].ordernumber);
      this.roadmapinfo = { ...this.roadmap[0] };
      this.orderinfo = { ...this.order[0] };
      this.roadmapcomfirmed = true;
      this.ordercomfirmed = true;
      this.$nextTick(() => {
        this.$refs.mainid.focus();
      });
    },
    handleResetroadmap() {
      this.resetroadmap = !this.resetroadmap;
      this.resetorder = !this.resetorder;
      this.roadmap = [];
      this.order = [];
      localStorage.removeItem('roadmapid');
      localStorage.removeItem('orderid');
      this.roadmapinfo = {};
      this.orderinfo = {};
      this.roadmapcomfirmed = false;
      this.ordercomfirmed = false;
    },
    async scanMaid(event) {
      const mainid = event.target.value;
      if (!mainid) {
        this.setAlert({
          show: true,
          type: 'error',
          message: this.$t('batchreowrk.mainidemptyalert'),
        });
        return;
      }
      if (this.mainidlist.some((item) => item.mainid === mainid)) {
        this.setAlert({
          show: true,
          type: 'error',
          message: this.$t('batchreowrk.mainidrepeatalert'),
        });
        return;
      }
      this.saving = true;
      const partstatuslist = await this.getElement({
        elementname: 'partstatus',
        query: `?query=mainid=="${mainid}"`,
      });
      this.saving = false;
      const obj = {
        mainid,
        ngcode: '-',
        ngdescription: '-',
        overallresult: 1,
        modestatus: 1,
        assetid: 4,
      };
      if (partstatuslist.length > 0) {
        obj.ngcode = partstatuslist[0].checkoutngcode || '-';
        obj.checkoutngcode = partstatuslist[0].checkoutngcode;
        if (
          this.ngconfiglist.length > 0
          && this.ngconfiglist
            .some((ngconfig) => ngconfig.ngcode === partstatuslist[0].checkoutngcode)
        ) {
          obj.ngdescription = this.ngconfiglist
            .find((ngconfig) => ngconfig.ngcode === partstatuslist[0].checkoutngcode)
            .ngdescription;
        }
      }
      this.mainidlist.push(obj);
      this.mainidlist = this.mainidlist.map((item, key) => ({
        ...item,
        key,
      }));
      this.mainid = '';
    },
    async handleDeleteMainid(index) {
      if (await this.$root.$confirm.open(this.$t('batchreowrk.deletealert'))) {
        this.$set(this.mainidlist, index, null);
        this.mainidlist = this.mainidlist.filter((i) => i).map((item, key) => ({
          ...item,
          key,
        }));
      }
    },
    async handleDeleteMainidist() {
      if (await this.$root.$confirm.open(this.$t('batchreowrk.deletealert'))) {
        this.selectedmainids.forEach((item) => {
          this.$set(this.mainidlist, item.key, null);
        });
        this.mainidlist = this.mainidlist.filter((i) => i).map((item, key) => ({
          ...item,
          key,
        }));
        this.selectedmainids = [];
      }
    },
    async handleConfirmRework() {
      if (!await this.$root.$confirm.open(this.$t('batchreowrk.confirmalert'))) {
        return;
      }
      const mainidlist = this.mainidlist.map((item) => ({
        ...item,
        ordername: this.orderinfo.ordername,
        ordernumber: this.orderinfo.ordernumber,
        ordertype: this.orderinfo.ordertype,
        customername: this.orderinfo.customername,
        producttypename: this.orderinfo.productname,
        productid: this.orderinfo.productid,
        roadmapid: this.roadmapinfo.id,
        lineid: this.orderinfo.lineid,
        linename: this.orderinfo.linename,
        sublineid: this.sublinelist[0] ? this.sublinelist[0].id : '-',
      }));
      this.saving = true;
      const result = await this.postBulkElement({
        elementname: 'partstatus',
        payload: mainidlist,
      });
      if (result) {
        this.mainidlist = [];
        this.handleResetroadmap();
        this.setAlert({
          show: true,
          type: 'success',
          message: this.$t('batchreowrk.successalert'),
        });
      } else {
        this.setAlert({
          show: true,
          type: 'error',
          message: this.$t('batchreowrk.failedalert'),
        });
      }
      this.saving = false;
    },
  },
};
</script>
